module.exports = __webpack_public_path__ + "static/media/American Veterinary Medical Association Logo.1710df4b.jpeg";